import { Avatar, Box, Container, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import text from "../../Assets/text.png";
import signature from "../../Assets/signature.png";
import initials from "../../Assets/initials.png";
import date from "../../Assets/date.png";
import checkmark from "../../Assets/checkmark.png";
import stamp from "../../Assets/stamp.png";
import driving_license from "../../Assets/driving_license.png";
import password_photo from "../../Assets/password_photo.png";
import dropdown from "../../Assets/dropdown.png";
import send_document from "../../Assets/send_document.png";
import coming_soon from "../../Assets/coming_soon.png";
import secure from "../../Assets/secure.png";
import Textfield from "../Textfield";

const styles = {
  container: {
    textAlign: "center",
  },
  sectionTitle: {
    fontWeight: "bold",
    fontSize: { xs: "2rem", md: "2.5rem" },
    color: "#1662A7",
    mb: { xs: 4, md: 6 },
  },
  functionCard: {
    p: 2,
    borderRadius: "12px",
    border: "1px solid #e0e0e0",
    backgroundColor: "#ffffff",
    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.05)",
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0px 8px 25px rgba(22, 98, 167, 0.15)",
      transform: "translateY(-3px)",
      borderColor: "#1662A7",
    },
  },
  functionIcon: {
    width: "30px",
    height: "30px",
    mr: 2,
  },
  functionLabel: {
    fontWeight: "medium",
    fontSize: { xs: "0.9rem", md: "1.1rem" },
    color: "#6E6B7B",
  },
  documentImage: {
    width: { xs: "100%", md: "95%" },
    borderRadius: "15px",
    boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.1)",
  },
  comingSoonImage: {
    width: { xs: "100%", md: "80%" },
  },
  developerText: {
    fontSize: { xs: "1rem", md: "1.4rem" },
    color: "#6E6B7B",
    lineHeight: 1.6,
    mb: 3,
  },
  highlight: {
    fontWeight: "bold",
    color: "#1662A7",
  },
  timelineText: {
    fontSize: { xs: "1rem", md: "1.4rem" },
    color: "#6E6B7B",
    lineHeight: 1.6,
  },
};

const FUNCTIONALITIES = [
  { src: text, label: "Text" },
  { src: signature, label: "Signature" },
  { src: initials, label: "Initials" },
  { src: date, label: "Date" },
  { src: checkmark, label: "Checkmark" },
  { src: stamp, label: "Stamp" },
  { src: driving_license, label: "Driving License" },
  { src: password_photo, label: "Passport Photo" },
  { src: dropdown, label: "Dropdown" },
];

function Functions() {
  return (
    <Box sx={{ py: { xs: 6, md: 10 } }}>
      <Container maxWidth="lg" sx={styles.container}>
        {/* Functions Title */}
        <Typography variant="h2" sx={styles.sectionTitle}>
          Functions
        </Typography>

        {/* Function Cards Grid */}
        <Grid container spacing={3} sx={{ mb: { xs: 6, md: 8 } }}>
          {FUNCTIONALITIES.map(({ src, label }, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box sx={styles.functionCard}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="flex-start"
                  sx={{ px: 1 }}
                >
                  <Box
                    component="img"
                    src={src}
                    alt={label}
                    sx={styles.functionIcon}
                  />
                  <Typography sx={styles.functionLabel}>{label}</Typography>
                </Stack>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Document Process Image */}
        <Box sx={{ mb: { xs: 6, md: 10 } }}>
          <Box
            component="img"
            src={send_document}
            alt="Document Process"
            sx={styles.documentImage}
          />
        </Box>

        {/* Developer Section */}
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={coming_soon}
              alt="Coming Soon"
              sx={styles.comingSoonImage}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Stack spacing={3} sx={{ textAlign: { xs: "center", md: "left" } }}>
              <Typography sx={styles.developerText}>
                For <span style={styles.highlight}>DEVELOPERS</span> and{" "}
                <span style={styles.highlight}>COMPANIES</span> requiring
                e-signatures embedded on company web pages or other advanced
                functions to enhance your workflow,
              </Typography>

              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                <Typography sx={styles.timelineText}>COMING SOON</Typography>
              </Stack>
            </Stack>
          </Grid>
        </Grid>

        {/* Email Signup */}
        <Box sx={{ mt: { xs: 6, md: 8 } }}>
          <Textfield />
        </Box>
      </Container>
    </Box>
  );
}

export default Functions;
